export default $axios => ({
  resource: 'score/tag',
  /**
   * Delete multiple ids
   */
  deleteMulti(data, config) {
    return $axios.delete('score/tags', data, config)
  }
})
